import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OverviewService } from 'src/app/services/overview.service';



/**
 * @title 2 Dialog with header, scrollable content and actions
 */
@Component({
  selector: 'app-dialog-category',
  templateUrl: './dialog-category.component.html',
})
export class AppCategoryContentComponent {
  siteId = ""
  constructor(@Inject(MAT_DIALOG_DATA) public data: ParamsData) {
    this.siteId = data.siteId;

  }
}



interface topcards {
  id: number;
  img: string;
  color: string;
  title: string;
  // subtitle: string;
  onClick: Function
}


interface ParamsData {
  companyId: string, siteId: string, systemId: string
}

@Component({
  selector: 'app-kantine-overview',
  templateUrl: './kantine-overview.component.html',
  styleUrl: './kantine-overview.component.css'
})



export class KantineOverviewComponent implements OnInit {
  params: ParamsData;
  systemName : string;
  constructor(public overviewService: OverviewService, public dialog: MatDialog, private route: ActivatedRoute, private router: Router) {

    this.route.params.subscribe(params => {
      console.log(params)
      this.params = params as ParamsData;

     
    })


  }
   async ngOnInit() {
    this.systemName = await this.overviewService.getSystemName(this.params)
   await this.overviewService.getActiveIssuesCount(this.params.companyId,this.params.siteId,this.params.systemId);
  }
  topcards: topcards[] = [
    {
      id: 1,
      color: 'primary',
      img: '/assets/images/svgs/icon-user-male.svg',
      title: 'Employees',
      // subtitle: '96',
      onClick: () => this.openMembership()
    },
    {
      id: 2,
      color: 'warning',
      img: '/assets/images/svgs/icon-briefcase.svg',
      title: 'Categories',
      // subtitle: '5',
      onClick: () => {
        this.openDialog(AppCategoryContentComponent)
      }
    },
    {
      id: 3,
      color: 'accent',
      img: '/assets/images/svgs/icon-mailbox.svg',
      title: 'Usergroup',
      // subtitle: '0',
      onClick: () => this.openMembership()
    }
  ];



  // Employees and groups live on the site's User & Group Management page.
  openMembership() {
    this.router.navigate(['/dashboard/sites', this.params.siteId, 'membership-test']);
  }

  openDialog(component) {

    const dialogRef = this.dialog.open(component, {
      width: '1200px',
      data: this.params
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }


btnCategoryClick(code){
  
}
}
